import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import {Subject} from 'rxjs';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {CommandService} from '@core/services/command.service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {take, takeUntil} from 'rxjs/operators';
import {SnackBarService} from '@core/services/snack-bar.service';
import {SendConfirmationEmailCommand} from '@features/firm/commands/firm.commands';
import {DialogService} from '@shared/services/dialog-service';

@Component({
    standalone: false,
    selector: 'app-user-list-roles-cell-viewer',
  templateUrl: './user-list-roles-cell-viewer.component.html',
  styleUrls: ['./user-list-roles-cell-viewer.component.scss']
})
export class UserListRolesCellViewerComponent implements OnInit, CellComponent {
  fieldDefinition: FieldDefinition;
  invalidateSubject: InvalidateSubject;
  item: any;
  roles: any;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  ngUnsubscribe$: Subject<void> = new Subject<void>();
  constructor(private commandService: CommandService,
              private dialogService: DialogService,
              private snackBarService: SnackBarService) { }

  ngOnInit() {

  }

  updateUserRole(item: any) {
    if (item.cells.UserRoles.displayText === 'Stakeholder') {
      return;
    }
    const updatedRole = (item.cells.UserRoles.displayText === 'Administrator') ? 'a Power User' : 'an Administrator';
    const newRole = (item.cells.UserRoles.displayText === 'Administrator') ? 'Power User' : 'Administrator';
    const title = 'Change User Role';
    const message = 'Are you sure you want to make this user ' + updatedRole + '?';
    this.dialogService.showYesNoDialog(title, message).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(result => {
      if (result.action === 'OK') {
        const command = new PlatformCommand('UpdateUserListRolesCommand', Api.AdminPanel);
        command.setValue('CompanyId', item.cells.CompanyId.value);
        command.setValue('Email', item.cells.Email.value);
        command.setValue('NewRole', newRole);
        this.commandService.executePlatformCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(response => {
          this.snackBarService.showInformation('User Role Updated!');
          item.cells.UserRoles.displayText = newRole;
          item.cells.UserRoles.value = [newRole];
          item.cells.UserRoles.isEdited = true;
          this.valueChanged.emit(item.cells.UserRoles);
        }, err => {
          this.snackBarService.showError(err.fieldValues['SnackBarMessage']);
        });
      }
    });
  }
}
